<template>
  <div>
    <div class="resilience-chart" :class="setSize">
      <img v-if="msize=='small'" class="user-image-display pointer" :src="userDisplayImage(profile)" @click="redirectToProfile" />
      <!-- <img v-else-if="msize=='medium'" class="user-image-display medium" :src="userDisplayImage(profile)" /> -->
      <img v-else class="user-image-display" :src="userDisplayImage(profile)" />

      <canvas
        :id="mid"
        v-if="msize=='small'"
        style="display: inline-block; width: 85px; height: 60px;"
      ></canvas>
      <!-- <canvas :id="mid" v-else-if="msize=='medium'" style="width: 415px;height:254"></canvas> -->
      <canvas :id="mid" v-else style="display: block; width: 350px; height: 250px;"></canvas>

      <h2
        v-if="msize=='small'"
        class="truncate"
        style="width: 250px;position:absolute;left: 90px;top:25px"
      >
        <span style="color:#aaa;width:100%">Hi,</span>&nbsp;
        <b>{{profile.display_name}}</b>
      </h2>

      <span
        v-show="!isHideLegend"
        v-for="(i, inx) in resilienceColor"
        :key="inx"
        class="legend-stl"
        :class="i.section"
      >
        <img
          @click="redirect(i)"
          :style="{color: i.color}"
          class="avatar"
          shape="square"
          :src="i.logo"
        />
        <!-- <span :style="{color: i.color}">{{i.section}}</span> -->
      </span>
    </div>
    <div class="total-points-wrapper">
      <div v-if="!isHideLegend" @click="viewInfo()">
        <p style="font-size:16px">{{total}} Total Resiliency Points
        <Icon v-if="aboutPoints" style="font-size: 20px;vertical-align: middle;" type="ios-information"></Icon></p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.total-points-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.total-points-wrapper > div {
  color: #aeaeae;
  font-size: 80%;
}
.resilience-chart {
  width: 320px;
  height: 260px;
  position: relative;
  clear: both;
  margin: 0 auto;
}
.resilience-chart > .user-image-display {
  position: absolute;
  top: calc(100% - 191px);
  left: calc(100% - 210px);
  border-radius: 320px;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.resilience-chart .legend-stl {
  position: absolute;
  width: 92px;
  height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.resilience-chart .legend-stl .avatar {
  width: 30px;
  height: 30px;
  margin-left: 16px;
}
.resilience-chart .legend-stl span {
  font-size: 11px;
  margin-top: 3px;
}
.resilience-chart .legend-stl.cope {
  right: 0;
  top: 0;
}
.resilience-chart .legend-stl.thrive {
  left: 0;
  top: 0;
}
.resilience-chart .legend-stl.nourish {
  left: 0;
  bottom: 0;
}
.resilience-chart .legend-stl.heal {
  right: 0;
  bottom: 0;
}
.resilience-chart.is-small > .user-image-display {
  width: 40px;
  height: auto;
  top: 20px;
  left: 30px;
}
.resilience-chart > .user-image-display.medium {
  top: 27px;
  left: 61px;
}
.is-small {
  width: 100px;
  height: 80px;
  margin: 0;
  margin-bottom: -20px;
  margin-left: -24px;
}
.resilience-chart.is-medium {
  width: 100%;
  height: 170px;
}
</style>

<script>
import Utils from "@/utils.js";
import { mapGetters } from "vuex";
import _get from "lodash/get";
import _findIndex from "lodash/findIndex";
import copeImg from "@/assets/svg/cope.svg";
import thriveImg from "@/assets/svg/thrive.svg";
import nourishImg from "@/assets/svg/nourish.svg";
import healImg from "@/assets/svg/heal.svg";

export default {
  props: {
    msize: {
      type: String,
      default: "normal"
    },
    mid: {
      type: String,
      default: "prof-res"
    },
    profile: {
      type: Object,
      required: true
    },
    isHideLegend: {
      type: Boolean,
      default: false
    },
    isSliceClickable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      resilienceColor: [
        {
          section: "cope",
          color: "#1E89A7",
          logo: copeImg
        },
        {
          section: "thrive",
          color: "#F19B2F",
          logo: thriveImg
        },
        {
          section: "nourish",
          color: "#83CA27",
          logo: nourishImg
        },
        {
          section: "heal",
          color: "#4E1C9B",
          logo: healImg
        }
      ]
    };
  },
  computed: {
    ...mapGetters("points", ["getCurrentUserResiliency"]),
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    aboutPoints() {
      return Utils.getBrandResourcefieldId(this.brandInfo, 'about_points')
    },
    cope() {
      return _get(this.getCurrentUserResiliency, "Cope", 0);
    },
    heal() {
      return _get(this.getCurrentUserResiliency, "Heal", 0);
    },
    thrive() {
      return _get(this.getCurrentUserResiliency, "Thrive", 0);
    },
    nourish() {
      return _get(this.getCurrentUserResiliency, "Nourish", 0);
    },
    total() {
      let mTotal = (
        parseFloat(this.cope) + 
        parseFloat(this.nourish) + 
        parseFloat(this.thrive) + 
        parseFloat(this.heal)
      );
      let str = mTotal.toFixed(0);
      return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setSize() {
      if (this.msize == "small") return "is-small";
      if (this.msize == "medium") return "is-medium";

      return "is-normal";
    }
  },
  methods: {
    viewInfo() {
      this.$router.push(`/feed/${this.aboutPoints}`);
    },
    redirect(i) {
      let indx = _findIndex(this.resilienceColor, { section: i.section });
      this.$router.push(`/library?section=${parseInt(indx) + 1}`);
    },
    userDisplayImage() {
      return Utils.getDisplayImage("user", this.profile, "medium");
    },
    handleSliceClick(event, slice) {
      if(!this.isSliceClickable) {
        return false
      }

      if (slice && slice[0]) {
        let category =
          slice[0]._index == 0
            ? "cope"
            : slice[0]._index == 1
            ? "heal"
            : slice[0]._index == 2
            ? "nourish"
            : "thrive";

        // if (category == "cope") this.$router.push(`/library?section=1`);
        // if (category == "thrive") this.$router.push(`/library?section=2`);
        // if (category == "nourish") this.$router.push(`/library?section=3`);
        // if (category == "heal") this.$router.push(`/library?section=4`);

        this.$store.dispatch("points/getCurrentUserCategoryLog", {
            journalId: this.userInfo.journal_id,
            category: category
        })
        // open points breakdown modal
        this.$store.commit("points/setModalCategory", category)
        this.$store.commit("points/setShowPointsModal", true)
      }
    },
    redirectToProfile() {
      this.$router.push(`/profile/${this.profile.id}`)
    }
  },
  mounted() {
    setTimeout(() => {
      var config = {
        type: "doughnut",
        data: {
          datasets: [
            {
              data: [this.cope, this.heal, this.nourish, this.thrive],
              backgroundColor: [
                this.resilienceColor[0].color,
                this.resilienceColor[3].color,
                this.resilienceColor[2].color,
                this.resilienceColor[1].color
              ],
              borderWidth: this.msize == "small" ? 0 : 5
            }
          ]
        },
        options: {
          plugins: {
            labels: {
              render: "percentage",
              fontColor: "#fff",
              textShadow: true,
              fontSize: this.msize == "normal" ? 12 : 0,
              precision: 0
            }
          },
          tooltips: {
            enabled: false
          },
          animation: {
            animateScale: true,
            animateRotate: true
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          onClick: this.handleSliceClick
        }
      };
      var ctx = document.getElementById(this.mid);
      window.myDoughnut = new Chart(ctx, config);
    }, 1500);
  }
};
</script>